// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3213bd91","453":"dc262ca4","455":"b5e289ce","977":"4b6d55d8"}[chunkId] + ".chunk.js";
};